import axios from "axios";
import { mapDataToFormData } from "../../helpers/global";
export default class InfoScreenOption {
    constructor(name, input, toggleClass, container) {
        this.name = name;
        this.input = input;
        this.toggleClass = toggleClass;
        this.container = container;
        this.initEvents();
    }
    initEvents() {
        this.input.addEventListener('change', () => {
            this.input.checked
                ? this.container.classList.add(this.toggleClass)
                : this.container.classList.remove(this.toggleClass);
            this.persist();
        });
    }
    persist() {
        axios.post(ajaxurl, mapDataToFormData({
            action: 'ac_admin_screen_options',
            _ajax_nonce: AC._ajax_nonce,
            option_name: this.name,
            option_value: this.input.checked ? 1 : 0
        }));
    }
}
